var React = require('react');

function LinkIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.5","y":"0.5","width":"79","height":"79","rx":"39.5","stroke":"#54525C","key":0}),React.createElement("path",{"d":"M42.2328 48.2101V43.7714C42.2328 43.7714 33.3614 42.4362 28.0369 49.9867C27.6741 50.5035 29.8118 35.7739 42.2328 34.8856V30L52 39.1037L42.2328 48.2101Z","fill":"#54525C","key":1})]);
}

LinkIcon.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = LinkIcon;

LinkIcon.default = LinkIcon;
